(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1146],{

/***/ 51146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FivaNavLayout_FivaNavLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./components/_Navbars/FivaNavbar/FivaNavbar.module.css
var FivaNavbar_module = __webpack_require__(60210);
var FivaNavbar_module_default = /*#__PURE__*/__webpack_require__.n(FivaNavbar_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 9 modules
var es_button = __webpack_require__(14726);
// EXTERNAL MODULE: ./components/_SharedComponents/CompareButton/CompareButton.module.css
var CompareButton_module = __webpack_require__(67376);
var CompareButton_module_default = /*#__PURE__*/__webpack_require__.n(CompareButton_module);
;// CONCATENATED MODULE: ./components/_SharedComponents/CompareButton/CompareButton.tsx



function CompareButton(param) {
    var _lightColor = param.lightColor, lightColor = _lightColor === void 0 ? false : _lightColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_button/* default */.ZP, {
        type: "primary",
        size: "large",
        className: lightColor ? (CompareButton_module_default()).lightButtonClass : (CompareButton_module_default()).buttonClass,
        children: [
            "Comparar",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginLeft: "10px"
                },
                children: lightColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/icons/UpVectorPurple.svg",
                    alt: "Up"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/icons/UpVector.svg",
                    alt: "Up"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./constants/_pages.ts
var _pages = __webpack_require__(17179);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/collapse.context.tsx
var collapse_context = __webpack_require__(78752);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-down.js
var chevron_down = __webpack_require__(8971);
;// CONCATENATED MODULE: ./components/_Navbars/FivaNavbar/FivaNavbar.tsx











var FivaNavbar = function() {
    var LOGO = "/icons/FivaBig.svg";
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var ref = (0,react.useContext)(collapse_context/* CollapseContext */.m), collapse = ref.collapse, setCollapse = ref.setCollapse;
    var contentRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), height = ref1[0], setHeight = ref1[1];
    var collapseTimeout;
    (0,react.useEffect)(function() {
        setCollapse(false);
    }, []);
    (0,react.useEffect)(function() {
        if (collapse) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        collapse
    ]);
    var handleMouseEnter = function() {
        clearTimeout(collapseTimeout);
        setCollapse(true);
    };
    var handleMouseLeave = function() {
        collapseTimeout = setTimeout(function() {
            setCollapse(false);
        }, 300) // Delay in milliseconds
        ;
    };
    var addCollapse = collapse && {
        minHeight: "56px"
    };
    var collapseStyle = {
        transition: "height 0.5s ease-out, padding 0.5s ease-out",
        height: "".concat(height, "px"),
        overflow: "hidden",
        width: "100%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (FivaNavbar_module_default()).container,
        style: (0,_object_spread/* default */.Z)({}, addCollapse),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FivaNavbar_module_default()).flexContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FivaNavbar_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: LOGO,
                                alt: "Fiva Logo",
                                width: 130,
                                height: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FivaNavbar_module_default()).links,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: pathname === "/" ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: "Ahorra con Fiva"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/para-empresas",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: pathname === "/para-empresas" ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: "Para empresas"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onMouseEnter: handleMouseEnter,
                                onMouseLeave: handleMouseLeave,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: pathname === _pages/* Pages.energy */.i.energy ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: [
                                        "Luz",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                            strokeWidth: "1",
                                            size: 15
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: pathname === "/blog" ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: "Blog"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/contacto",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: pathname === "/contacto" ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: "Contacto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/colaboradores",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: pathname === "/colaboradores" ? (FivaNavbar_module_default()).selectedUnderline : (FivaNavbar_module_default()).underline,
                                    children: "Colaboradores"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/sube-tu-factura",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareButton, {})
                            })
                        })
                    })
                ]
            }),
            collapse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FivaNavbar_module_default()).collapseContainer,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: contentRef,
                    style: collapseStyle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            color: "var(--fiva-color)",
                            padding: "2rem 7%",
                            backgroundColor: "var(--fiva-secondary-color, #ddfffd)",
                            borderRadius: "40px",
                            gap: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/precio-luz-hoy",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (FivaNavbar_module_default()).underlineCollapse,
                                    children: "Precio de la luz"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/solar",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (FivaNavbar_module_default()).underlineCollapse,
                                    children: "Autoconsumo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: _pages/* Pages.energy */.i.energy,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (FivaNavbar_module_default()).underlineCollapse,
                                    children: "Te asesoramos"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var FivaNavbar_FivaNavbar = (FivaNavbar);

// EXTERNAL MODULE: ./components/_Navbars/FivaNavbarPhone/FivaNavbarPhone.module.css
var FivaNavbarPhone_module = __webpack_require__(41813);
var FivaNavbarPhone_module_default = /*#__PURE__*/__webpack_require__.n(FivaNavbarPhone_module);
;// CONCATENATED MODULE: ./components/_Navbars/FivaNavbarPhone/FivaNavbarPhone.tsx










var FivaNavbarPhone = function() {
    var ref = (0,react.useContext)(collapse_context/* CollapseContext */.m), collapse = ref.collapse, setCollapse = ref.setCollapse;
    var contentRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), height = ref1[0], setHeight = ref1[1];
    var ref2 = (0,react.useState)(null), subMenu = ref2[0], setSubMenu = ref2[1];
    (0,react.useEffect)(function() {
        setCollapse(false);
    }, []);
    (0,react.useEffect)(function() {
        if (collapse) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        collapse
    ]);
    (0,react.useEffect)(function() {
        if (subMenu) {
            setHeight(contentRef.current.scrollHeight);
        }
    }, [
        subMenu
    ]);
    var toggleSubMenu = function(menu) {
        if (subMenu === menu) {
            setSubMenu(null);
        } else {
            setSubMenu(menu);
        }
    };
    var addCollapse = collapse ? {
        minHeight: "56px"
    } : {};
    var collapseStyle = {
        height: "".concat(height, "px")
    };
    var LOGO = "/icons/FivaPhone.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FivaNavbarPhone_module_default()).container,
        style: (0,_object_spread/* default */.Z)({}, addCollapse),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FivaNavbarPhone_module_default()).flexContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FivaNavbarPhone_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: LOGO,
                                alt: "Fiva Logo",
                                width: 95,
                                height: 30
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FivaNavbarPhone_module_default()).menuIcon,
                        onClick: function() {
                            collapse ? setCollapse(false) : setCollapse(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/icons/menu.svg",
                            alt: "Menu Icon",
                            height: 40,
                            width: 40
                        })
                    })
                ]
            }),
            collapse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: contentRef,
                className: (FivaNavbarPhone_module_default()).collapseContainer,
                style: collapseStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FivaNavbarPhone_module_default()).collapseContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FivaNavbarPhone_module_default()).underline,
                                children: "Ahorra con Fiva"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (FivaNavbarPhone_module_default()).underline,
                                    onClick: function() {
                                        return toggleSubMenu("luz");
                                    },
                                    children: [
                                        "Luz",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                            strokeWidth: "1",
                                            size: 15
                                        })
                                    ]
                                }),
                                subMenu === "luz" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FivaNavbarPhone_module_default()).subMenu,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/precio-luz-hoy",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (FivaNavbarPhone_module_default()).underline,
                                                children: "Precio de la luz"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/solar",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (FivaNavbarPhone_module_default()).underline,
                                                children: "Autoconsumo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: _pages/* Pages.energy */.i.energy,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (FivaNavbarPhone_module_default()).underline,
                                                children: "Te asesoramos"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/solar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FivaNavbarPhone_module_default()).underline,
                                children: "Autoconsumo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/blog",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FivaNavbarPhone_module_default()).underline,
                                children: "Blog"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contacto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FivaNavbarPhone_module_default()).underline,
                                children: "Contacto"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/colaboradores",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FivaNavbarPhone_module_default()).underline,
                                children: "Colaboradores"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/sube-tu-factura",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareButton, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var FivaNavbarPhone_FivaNavbarPhone = (FivaNavbarPhone);

// EXTERNAL MODULE: ./Layout/FivaNavLayout/FivaNavLayout.module.css
var FivaNavLayout_module = __webpack_require__(73516);
var FivaNavLayout_module_default = /*#__PURE__*/__webpack_require__.n(FivaNavLayout_module);
;// CONCATENATED MODULE: ./Layout/FivaNavLayout/FivaNavLayout.tsx




var FivaNavLayout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FivaNavLayout_module_default()).big,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FivaNavbar_FivaNavbar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FivaNavLayout_module_default()).small,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FivaNavbarPhone_FivaNavbarPhone, {})
            })
        ]
    });
};
/* harmony default export */ var FivaNavLayout_FivaNavLayout = (FivaNavLayout);


/***/ }),

/***/ 73516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"FivaNavLayout_small__v_aeq","big":"FivaNavLayout_big__J2oX_"};

/***/ }),

/***/ 60210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FivaNavbar_container__sF_KY","flexContainer":"FivaNavbar_flexContainer__9AhC3","links":"FivaNavbar_links__2vXBW","underline":"FivaNavbar_underline__cT8ji","selectedUnderline":"FivaNavbar_selectedUnderline__QzxBQ","underlineCollapse":"FivaNavbar_underlineCollapse__PQ5U4","logo":"FivaNavbar_logo__pp8_f","compareButton":"FivaNavbar_compareButton__lRv2z","compareBtn":"FivaNavbar_compareBtn__IBPRC","collapseContainer":"FivaNavbar_collapseContainer__Bh0JO","title":"FivaNavbar_title__KZav9","selectedUnderli":"FivaNavbar_selectedUnderli__KZfFv","underlineCollapsene":"FivaNavbar_underlineCollapsene__fEAYs"};

/***/ }),

/***/ 41813:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FivaNavbarPhone_container__6j266","flexContainer":"FivaNavbarPhone_flexContainer__c7HvF","logo":"FivaNavbarPhone_logo__V_bBq","menuIcon":"FivaNavbarPhone_menuIcon__cNfS8","collapseContainer":"FivaNavbarPhone_collapseContainer__Ya8yN","collapseContent":"FivaNavbarPhone_collapseContent__0rYGv","subMenu":"FivaNavbarPhone_subMenu__oo4OC","underline":"FivaNavbarPhone_underline__UwLhp"};

/***/ }),

/***/ 67376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonClass":"CompareButton_buttonClass__R7io1","lightButtonClass":"CompareButton_lightButtonClass__FnEbx"};

/***/ })

}]);